module.exports = __webpack_public_path__ + "img/fee-blue.88c4065f.svg";